import { environment } from 'environments/environment';

export declare type AvailableWebsitesLegacy =
  | 'BookingFlow'
  | 'Invoices'
  | 'CabinBag'
  | 'AddBags'
  | 'SpecialEquipment'
  | 'Checkin'
  | 'FlightChange'
  | 'NameChange'
  | 'SeatChange'
  | 'ChangeItinerary'
  | 'UkTravel';

export declare type AvailableWebsites =
  | 'Checkin'
  | 'SeatChange'
  | 'AddBags'
  | 'CabinBag'
  | 'NameChange'
  | 'CancelFlight'
  | 'RequestInvoice'
  | 'Invoices'
  | 'ResendItinerary'
  | 'FlightChange'
  | 'ChangeItinerary'
  | 'BookingFlow'
  | 'SpecialEquipment'
  | 'UkTravel';

export const redirectRoutes_Legacy: Record<AvailableWebsitesLegacy, string> = {
  BookingFlow: `${environment.smartBaseUrl}/booking/flightSearch?culture=`,
  Invoices: `${environment.configurations.newInvoiceConfig?.url}`,
  AddBags: `${environment.smartBaseUrl}/ChangeBaggage.aspx?SearchOption=EMAIL&culture=`,
  CabinBag: `${environment.smartBaseUrl}/ChangeCabinBaggage.aspx?SearchOption=EMAIL&culture=`,
  SpecialEquipment: `${environment.smartBaseUrl}/ChangeSpecialEquipment.aspx?SearchOption=EMAIL&culture=`,
  Checkin: `${environment.smartWeb}/checkin`,
  FlightChange: `${environment.smartBaseUrl}/SearchChange.aspx?event=changeflight&SearchOption=EMAIL&culture=`,
  NameChange: `${environment.smartBaseUrl}/ChangePaxName.aspx?SearchOption=EMAIL&culture=`,
  SeatChange: `${environment.smartBaseUrl}/ChangeSeat.aspx?SearchOption=EMAIL&culture=`,
  ChangeItinerary: `${environment.smartBaseUrl}/AgencyChangeItinerary.aspx?SearchOption=EMAIL&culture=`,
  UkTravel: `${environment.configurations.UkTravelConfig?.url}`
};

export const redirectRoutes: Record<AvailableWebsites, string> = {
  Checkin: `${environment.smartWeb}/checkin`,
  SeatChange: `${environment.configurations.mmbConfig.url}manage?flow=seats&d=`,
  AddBags: `${environment.configurations.mmbConfig.url}manage?flow=bags&d=`,
  CabinBag: `${environment.configurations.mmbConfig.url}manage?flow=cabinBags&d=`,
  NameChange: `${environment.configurations.mmbConfig.url}manage?flow=changeName&d=`,
  CancelFlight: `${environment.configurations.mmbConfig.url}manage?flow=cancelFlight&d=`,
  ResendItinerary: `${environment.configurations.mmbConfig.url}manage?flow=resendItinerary&d=`,
  RequestInvoice: `${environment.configurations.mmbConfig.url}manage?flow=requestInvoice&d=`,
  FlightChange: `${environment.smartBaseUrl}/SearchChange.aspx?event=changeflight&SearchOption=EMAIL&culture=`,
  ChangeItinerary: `${environment.smartBaseUrl}/AgencyChangeItinerary.aspx?SearchOption=EMAIL&culture=`,
  BookingFlow: `${environment.smartBaseUrl}/booking/flightSearch?culture=`,
  SpecialEquipment: `${environment.smartBaseUrl}/ChangeSpecialEquipment.aspx?SearchOption=EMAIL&culture=`,
  Invoices: `${environment.configurations.newInvoiceConfig?.url}`,
  UkTravel: `${environment.configurations.UkTravelConfig?.url}`
};
